import { Button, Checkbox, Col, Form, Input, Row, Select, Space } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { showError, showMessage, useLayoutBreaks } from "helpers/utility";
import useAjax from "helpers/ajax";
import CInput from "components/CInput";
import { useEffect, useState } from "react";
import CSelect from "components/CSelect";

const CreateCompany = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const breaks = useLayoutBreaks();
  const { fetch, get } = useAjax();
  const edit = state ? true : false;
  const [companyTypes, setCompanyTypes] = useState([]);

  const onFinish = (values) => {
    const method = edit ? "put" : "post";
    const data = { ...values, companyID: state?.companyID };
    fetch(method, "api/v1/companies", { ...data })
      .then((resp) => {
        showMessage(resp.success, resp.message).then(() => {
          if (resp.success) {
            navigate("/admin/companies");
          }
        });
      })
      .catch((err) => {
        showError(err);
      });
  };

  useEffect(() => {
    get("api/v1/lookups/companytypes")
      .then((resp) => {
        setCompanyTypes(resp);
      })
      .catch((err) => {
        showError(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form
      layout="vertical"
      initialValues={{ ...state, active: !edit ? true : state.active }}
      onFinish={onFinish}
    >
      <Row gutter={24}>
        <Col {...breaks}>
          <Form.Item
            label="Company name"
            name="companyName"
            rules={[{ required: true }]}
          >
            <CInput />
          </Form.Item>
          <Form.Item
            label="Company type"
            name="companyTypeID"
            rules={[{ required: true }]}
          >
            <CSelect allowClear={true}>
              {companyTypes.map((r) => (
                <Select.Option key={r.value} value={r.value}>
                  {r.text}
                </Select.Option>
              ))}
            </CSelect>
          </Form.Item>
          <Form.Item
            label="Company address"
            name="companyAddress"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Email address"
            name="emailAddress"
            rules={[{ required: true }, { type: "email" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Contact no."
            name="contactNo"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>

          <Form.Item valuePropName="checked" label="Active" name="active">
            <Checkbox />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                Save
              </Button>
              <Button
                htmlType="button"
                onClick={() => {
                  navigate("/admin/companies");
                }}
              >
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
export default CreateCompany;
